module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av370-783624204dd8e9572ac06b07fa15e88a.jpg";